/**
 * API fetch helper that respects REACT_APP_API_URL for production.
 * Use this instead of raw fetch() for API calls.
 */
const API_BASE = process.env.REACT_APP_API_URL || '';

export function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  return fetch(url, options);
}
